module.exports = __webpack_public_path__ + "media/icons/widget-section-e@3x-17a037e4.svg";